const isFormData = (value: unknown): value is FormData =>
  typeof FormData !== "undefined" && value instanceof FormData;

const isBlob = (value: unknown): value is Blob =>
  typeof Blob !== "undefined" && value instanceof Blob;

const isFile = (value: unknown): value is File =>
  typeof File !== "undefined" && value instanceof File;

const isUrlSearchParams = (value: unknown): value is URLSearchParams =>
  typeof URLSearchParams !== "undefined" && value instanceof URLSearchParams;

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (Object.prototype.toString.call(value) !== "[object Object]") {
    return false;
  }

  const prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.prototype;
};

const shouldPreserveValue = (value: unknown): boolean =>
  value === null ||
  typeof value !== "object" ||
  value instanceof Date ||
  isFormData(value) ||
  isBlob(value) ||
  isFile(value) ||
  isUrlSearchParams(value);

export const trimRequestPayload = <T>(value: T): T => {
  if (typeof value === "string") {
    return value.trim() as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => trimRequestPayload(item)) as T;
  }

  if (shouldPreserveValue(value)) {
    return value;
  }

  if (isPlainObject(value)) {
    const trimmedEntries = Object.entries(value).map(
      ([key, entryValue]): [string, unknown] => [
        key,
        trimRequestPayload(entryValue),
      ],
    );

    return Object.fromEntries(trimmedEntries) as T;
  }

  return value;
};
